import React from "react";

export default () => {
  return (
    <svg
      width="159px"
      height="103px"
      viewBox="0 0 159 103"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Human Comfort</title>
      <defs>
        <linearGradient
          x1="42.9298696%"
          y1="54.4960845%"
          x2="-8.42366461%"
          y2="34.0345651%"
          id="hc-linearGradient-1"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M39.7497,16.0512 C43.94875,16.0512 47.349155,19.44955 47.3472042,23.6507 C47.3472042,27.0489 44.5974,29.8497 41.1482,29.8497 C38.3495,29.8497 36.0487,27.551 36.0487,24.7502 C36.0487,22.4514 37.8983,20.551 40.2479,20.551 C42.1483,20.551 43.7479,22.1018 43.7479,24.051 C43.7479,24.40062 43.39831,24.7014 43.0487,24.7014 C42.69908,24.7014 42.3983,24.40061 42.3983,24.051 C42.3983,22.8498 41.4471,21.9006 40.2479,21.9006 C38.6991,21.9006 37.3983,23.1506 37.3983,24.7502 C37.3983,26.801 39.0975,28.5002 41.1483,28.5002 C43.7987,28.5002 45.9979,26.3498 45.9979,23.6506 C45.9979,20.2014 43.1971,17.4006 39.7479,17.4006 L39.7479,17.4006 L2.2989,17.4006 C1.90048,17.4006 1.5997,17.09981 1.5997,16.7502 C1.5997,16.35178 1.94929,16.051 2.2989,16.051 L2.2989,16.051 Z M34.1504,18.5995 C34.548845,18.5995 34.849625,18.90026 34.8008,19.2987 C34.8008,19.64832 34.5,19.9491 34.1504,19.9491 L34.1504,19.9491 L18.6504,19.9491 C18.30078,19.9491 18,19.64831 18,19.2987 C18,18.90028 18.30079,18.5995 18.6504,18.5995 L18.6504,18.5995 Z M16.1504,18.5995 C16.548845,18.5995 16.849625,18.90026 16.8008,19.2987 C16.8008,19.64832 16.5,19.9491 16.1504,19.9491 L16.1504,19.9491 L0.6504,19.9491 C0.30078,19.9491 -3.55271368e-15,19.64831 -3.55271368e-15,19.2987 C-3.55271368e-15,18.90028 0.30079,18.5995 0.6504,18.5995 L0.6504,18.5995 Z M30.3494,1.1505 C33.7476,1.1505 36.5484,3.9003 36.5484,7.3497 C36.5484,11.55075 33.15005,14.9492 28.9489,14.9492 L28.9489,14.9492 L2.999902,14.9492 C2.650282,14.9492 2.349502,14.59962 2.349502,14.25 C2.349502,13.90038 2.650292,13.5996 2.999902,13.5996 L2.999902,13.5996 L28.9979,13.5996 C32.4471,13.5996 35.2479,10.7988 35.2479,7.3496 C35.2479,4.6992 33.0975,2.5 30.3983,2.5 C28.3475,2.5 26.6483,4.1992 26.6483,6.25 C26.6483,7.7988 27.8983,9.0996 29.4979,9.0996 C30.6991,9.0996 31.6483,8.1484 31.6483,6.9492 C31.6483,6.55078 31.94909,6.25 32.2987,6.25 C32.64832,6.25 32.9491,6.59959 32.9491,6.9492 C32.9491,8.8496 31.3983,10.4492 29.4491,10.4492 C27.1503,10.4492 25.2499,8.5996 25.2499,6.25 C25.2499,3.4513 27.5486,1.1505 30.3494,1.1505 Z M43.04828,5.5002 C45.44868,5.5002 47.34908,7.4006 47.34908,9.7502 C47.34908,12.5996 45.04843,14.90037 42.24958,14.9492 L42.24958,14.9492 L35.7498,14.9492 C35.35138,14.9492 35.0506,14.59962 35.0506,14.25 C35.0506,13.90038 35.40019,13.5996 35.7498,13.5996 L35.7498,13.5996 L42.1483,13.5996 C44.2987,13.5996 45.9979,11.8496 45.9979,9.75 C45.9979,8.1504 44.6483,6.8496 43.0487,6.8496 C41.8495,6.8496 40.8495,7.8496 40.8495,9.0488 C40.8495,9.9492 41.5995,10.6992 42.4999,10.6992 C42.84952,10.6992 43.1503,10.99998 43.1503,11.3496 C43.1503,11.69922 42.84951,12 42.49943,12.0002 C40.84903,12.0002 39.499435,10.69945 39.49748,9.051 C39.49748,7.0998 41.09908,5.5002 43.04828,5.5002 Z M22.5509,11.0994 C22.90052,11.0994 23.2013,11.34941 23.2013,11.7498 C23.2013,12.14822 22.90051,12.449 22.5509,12.449 L22.5509,12.449 L2.4999,12.449 C2.15028,12.449 1.8495,12.09942 1.8495,11.7498 C1.8495,11.40018 2.15029,11.0994 2.4999,11.0994 L2.4999,11.0994 Z"
          id="hc-path-2"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.6199324%"
          id="hc-linearGradient-3"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M56.7082039,0 L64,0 C65.1045695,-2.02906125e-16 66,0.8954305 66,2 L66,18 C66,19.1045695 65.1045695,20 64,20 L54.1803399,20 C50.3641461,20 47.2705098,16.9063637 47.2705098,13.0901699 C47.2705098,12.0174527 47.5202663,10.9594675 48,10 L51.3416408,3.31671843 C52.3579929,1.28401426 54.4355716,2.19383263e-15 56.7082039,0 Z"
          id="hc-path-4"
        ></path>
        <linearGradient
          x1="82.4351196%"
          y1="28.2164037%"
          x2="38.9715186%"
          y2="30.7676243%"
          id="hc-linearGradient-5"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M24.5701693,37.7252892 C26.2270235,37.7252892 27.5701693,39.068435 27.5701693,40.7252892 C27.5701693,42.3821435 26.2270235,43.7252892 24.5701693,43.7252892 C21.7758262,43.7252892 19.0877821,43.770512 16.404374,43.9155345 C15.202763,43.9804746 14.1274077,44.0618222 13.2069485,44.1594182 L12.658,44.222 L14.9141508,47.8921702 C15.8136255,49.3845339 16.5277144,50.6683494 17.1312024,51.9187799 C18.7685681,55.3114106 19.4662613,58.1899328 18.859405,60.8256659 C18.4876539,62.4402765 16.8773897,63.4478132 15.2627792,63.0760621 C13.7058333,62.7175879 12.7133732,61.207486 12.9777953,59.6523574 L13.012383,59.4794363 C13.2368955,58.5043208 12.8228346,56.7960002 11.7276083,54.5266853 C11.2736105,53.5859993 10.7255306,52.5868108 10.0392749,51.4305586 L9.34601583,50.2929456 C8.66287304,49.1872451 7.37861584,47.1075875 6.93561947,46.3377586 L6.87821289,46.23694 C6.40238997,45.3902309 6.07442202,44.7045236 5.86763517,44.0580097 C5.42589497,42.6769202 5.43848843,41.3657713 6.53962129,40.1716629 C7.96912686,38.6214553 10.5924271,38.2208805 16.0805814,37.9242777 C18.8977103,37.7720283 21.6758859,37.7252892 24.5701693,37.7252892 Z M26.0628931,16.1855704 C27.3139738,16.8721723 27.7715743,18.4429743 27.0849724,19.694055 C22.7180065,27.6512525 17.1005212,31.3146006 8.02574752,31.5947939 C6.59932358,31.6388363 5.4072751,30.5181946 5.36323273,29.0917707 C5.31919035,27.6653467 6.43983204,26.4732983 7.86625598,26.4292559 C15.0548654,26.2072999 19.0424885,23.6068389 22.5544084,17.2076497 C23.2410103,15.956569 24.8118124,15.4989685 26.0628931,16.1855704 Z"
          id="hc-path-6"
        ></path>
        <linearGradient
          x1="44.9145979%"
          y1="31.2021401%"
          x2="72.5465075%"
          y2="33.7331584%"
          id="hc-linearGradient-7"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M32.3515571,17.213688 C35.3735951,25.920505 34.0786028,34.4515122 30.83703,40.6793903 C30.4124369,41.4951404 29.7978814,42.1478245 29.0757742,42.6114532 C28.4559367,43.4141237 27.4793753,43.9250763 26.3873233,43.9109252 C24.1645199,43.8821215 20.7204701,44.1673347 17.6657895,44.6373563 L16.8414043,44.7704006 C15.6359212,44.9744239 14.5765533,45.1973098 13.7468633,45.422944 L13.3627219,45.5326122 L13.034,45.636 L12.9627147,45.9953718 L12.4200644,49.2231259 C12.3596163,49.5649208 12.2997153,49.8873946 12.2357767,50.2138822 C11.8860663,51.9995975 11.4700592,53.5917036 10.9121644,55.1332636 C9.87867055,57.9889861 8.42217441,60.4611008 6.39470354,62.514464 C5.09710235,63.8286366 2.9798414,63.8420704 1.66566885,62.5444692 C0.400169348,61.2949273 0.340841911,59.2853168 1.4968805,57.9646761 L1.63566373,57.8154345 C2.92879131,56.5057926 3.89873578,54.8595033 4.62333222,52.8573179 C4.99792649,51.822249 5.29925634,50.718844 5.56207338,49.4719319 L5.71924913,48.681019 C5.88333026,47.7904883 6.18605629,45.963578 6.27598458,45.4099671 L6.35003082,44.9730993 C6.7298033,42.8546458 7.06050674,41.8535279 8.08855652,40.846595 C9.79915848,39.17113 15.7274263,37.9128484 21.3068194,37.4327176 C21.3820595,37.0088882 21.5133332,36.5881956 21.7031214,36.1809487 L21.8034417,35.9774623 C23.1837173,33.3256051 24.0295067,29.8602368 23.8271533,26.1257278 C21.2505022,28.1481347 17.8591191,28.6174057 11.3876923,28.8172179 C9.9612684,28.8612603 8.76921992,27.7406186 8.72517755,26.3141947 C8.68113518,24.8877707 9.80177686,23.6957223 11.2282008,23.6516799 L12.7474769,23.6005862 C19.0200931,23.3658283 20.5578515,22.919464 22.530489,19.7846418 C22.0894666,17.3583841 23.4692593,14.9066356 25.8714178,14.0728734 C28.5281709,13.1507444 31.4294281,14.556935 32.3515571,17.213688 Z"
          id="hc-path-8"
        ></path>
        <linearGradient
          x1="50%"
          y1="77.2873025%"
          x2="50%"
          y2="12.0632188%"
          id="hc-linearGradient-9"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M25.980097,43.0198813 C25.380097,43.0198813 24.855073,43.1698813 24.330097,43.394881 C21.8551209,41.2199053 18.7803367,40.9948813 15.5552166,40.7698573 L15.5552166,43.394881 C15.1052166,43.1698813 14.5802406,43.0198813 13.9802406,43.0198813 C13.4552165,43.0198813 13.0052645,43.1698813 12.5552165,43.394881 L12.5552165,40.7698573 C9.40521637,40.9948573 6.25521625,41.2198573 3.78033615,43.4698574 C3.25531213,43.1698573 2.73033611,43.0948573 2.13033608,43.0948573 C1.83033607,43.0948573 1.60531206,43.0948573 1.30531205,43.1698573 C2.13033608,41.894881 3.25531213,40.9948813 4.68028819,40.3198572 C6.78028827,39.2698572 9.10531236,38.8198572 11.4300485,38.6698572 C11.8050485,38.6698572 12.1800485,38.5948572 12.5550725,38.5948572 L12.5550725,30.919881 C12.5550725,30.769881 12.6300725,30.694881 12.7800725,30.694881 C13.6050965,30.619881 14.4300726,30.469881 15.2550486,30.394881 C15.4050486,30.394881 15.5550486,30.469881 15.5550486,30.619881 L15.5550486,38.5198812 C15.9300486,38.5198812 16.3050486,38.5948812 16.6800727,38.5948812 C19.0050968,38.7448812 21.3300728,39.1199052 23.4298329,40.1698572 C24.854857,40.9198573 25.979833,41.8198573 26.8048091,43.0948813 C26.5801211,43.0198813 26.280097,43.0198813 25.980097,43.0198813 Z"
          id="hc-path-10"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.6199324%"
          id="hc-linearGradient-11"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M14.2051206,42.6451217 C15.3301446,42.6451217 16.3051206,43.6200987 16.3051206,44.7451227 C16.3051206,45.8701468 15.4051206,46.8451228 14.2051206,46.8451228 C13.0800965,46.8451228 12.1051205,45.8701468 12.1051205,44.7451227 C12.1051205,43.6200987 13.0051205,42.6451217 14.2051206,42.6451217 Z M2.13024008,42.6451217 C3.33024013,42.6451217 4.23024017,43.6200987 4.23024017,44.7451227 C4.23024017,45.8701468 3.25526413,46.8451228 2.13024008,46.8451228 C1.00521604,46.8451228 0.0302400012,45.8701468 0.0302400012,44.7451227 C0.0302400012,43.6200987 0.930240037,42.6451217 2.13024008,42.6451217 Z M25.980001,42.4948817 C27.1800011,42.4948817 28.0800011,43.4698568 28.0800011,44.5948808 C28.0800011,45.7199049 27.1800011,46.6948809 25.980001,46.6948809 C24.854977,46.6948809 23.8800009,45.7199049 23.8800009,44.5948808 C23.8800009,43.4698568 24.780001,42.4948817 25.980001,42.4948817 Z"
          id="hc-path-12"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.6199324%"
          id="hc-linearGradient-13"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M27.7051211,30.1200012 C27.6301211,31.7700013 22.8302409,30.6450252 11.8051205,31.9949773 C0.0302400012,33.4949773 0.25536001,31.7699773 0.554880022,28.2449771 C0.704880028,26.5949771 3.40488014,25.394977 14.5046406,26.144977 C25.529761,26.8949771 27.7795211,28.4700011 27.7046411,30.1199532 L27.7051211,30.1200012 Z"
          id="hc-path-14"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.6199324%"
          id="hc-linearGradient-15"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M24.554881,25.920001 C23.3548809,25.695001 23.4298569,25.245025 23.8048809,24.345025 C24.254881,23.2200009 24.554881,22.0950249 24.779857,20.9700488 L25.079857,19.0950728 C25.229857,18.1200967 25.229857,17.1450727 25.079857,16.2450726 C25.004857,15.7950726 24.929857,15.3450726 24.929857,14.8200486 L24.404833,9.34516837 C24.329833,9.27016837 24.179833,6.42014426 24.329833,5.44516822 C24.929833,1.99516808 28.2298331,-0.329712013 31.6795933,0.270288011 L32.3545693,0.420288017 C33.7795933,0.645288026 34.7545694,1.99526408 34.5295454,3.42028814 L30.9295452,23.5202889 C30.6295452,25.395265 28.7545691,26.6702891 26.8795451,26.370289 L24.554881,25.920001 Z"
          id="hc-path-16"
        ></path>
        <linearGradient
          x1="38.7224171%"
          y1="31.2021401%"
          x2="100%"
          y2="33.7331584%"
          id="hc-linearGradient-17"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <circle
          id="hc-path-18"
          cx="21.7599988"
          cy="7.14399959"
          r="7.14399959"
        ></circle>
        <linearGradient
          x1="100%"
          y1="50%"
          x2="0%"
          y2="50%"
          id="hc-linearGradient-19"
        >
          <stop stopColor="#FFFFFF" offset="23.6829603%"></stop>
          <stop stopColor="#EFF8FD" stopOpacity="0" offset="100%"></stop>
        </linearGradient>
        <filter
          x="-7.1%"
          y="-9.3%"
          width="114.3%"
          height="118.7%"
          filterUnits="objectBoundingBox"
          id="hc-filter-20"
        >
          <feGaussianBlur stdDeviation="1" in="SourceGraphic"></feGaussianBlur>
        </filter>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="hc-linearGradient-21"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <rect
          id="hc-path-22"
          x="43"
          y="4.75"
          width="1.5"
          height="28.5"
          rx="0.25"
        ></rect>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="hc-linearGradient-23"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <polygon
          id="hc-path-24"
          points="83 70.9 33 70.9 33 72.5842105 36.3898119 72.5842105 36.3898119 102.9 39.6949039 102.9 42.2372628 77.6368421 74.6015594 77.6368421 77.1523793 102.9 80.457473 102.9 80.457473 72.5842105 82.9998319 72.5842105"
        ></polygon>
        <linearGradient
          x1="61.4604761%"
          y1="100%"
          x2="56.3354817%"
          y2="3.63212912%"
          id="hc-linearGradient-25"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M17.8222734,0 C19.4818656,2.58230754 20.0454799,5.46623555 19.1293304,8.10141704 C18.416186,10.1506788 16.906704,11.7648858 14.9006317,12.8537325 C14.861841,13.4388769 14.8520638,14.0260297 14.8703409,14.6112546 C14.8895271,15.0731511 14.9183095,15.5350477 14.9662719,15.9945548 C14.9782625,16.0998616 14.9902532,16.2027728 15.0022499,16.310469 L15.0022499,16.310469 L15.008,16.373 L15.0028794,16.3365766 C14.9801751,16.1935361 15.0143239,16.4631638 15.0121483,16.4163267 L15.009,16.382 L15.0142405,16.4109847 C15.0334267,16.5246698 15.0514127,16.6383534 15.0699987,16.7520355 L15.1293578,17.0930771 C15.2732513,17.8828779 15.4795047,18.6606703 15.7241305,19.4265155 C15.8560395,19.8333938 16.0047342,20.2402414 16.167814,20.6423101 C16.1798046,20.6662413 16.3165025,20.9965105 16.2157764,20.7571869 L16.239,20.812 L16.244,20.825 L16.248,20.834 L16.2808277,20.907664 L16.2808277,20.907664 L16.3476793,21.0563444 C16.4268186,21.2166941 16.5059641,21.3842242 16.5827089,21.5469633 C17.1546034,22.745491 17.6325808,23.9818431 17.9732314,25.2620207 C18.1605435,23.2309681 18.9311944,21.4075687 20.3167269,20.0247081 C22.2593541,18.0861394 25.0773024,17.3682054 28.1109345,17.7559069 C28.4946588,20.783385 27.7703777,23.5906672 25.820561,25.5295422 C23.9688598,27.3773749 21.3218598,28.1161639 18.4508418,27.8455049 C18.6238826,29.3811948 18.6212267,30.9188467 18.6212267,32.4723886 C18.6212267,33.1424848 18.0696436,33.6402842 17.4221012,33.6690064 C16.7745834,33.6977409 16.2229782,33.0994014 16.2229782,32.4723886 L16.2229782,32.4723886 L16.2229782,30.3184642 C16.2229782,29.6530979 16.1942019,28.9949612 16.1222521,28.3368244 C16.1102615,28.1932315 16.0934758,28.0496386 16.0742896,27.9060396 L16.0860958,28.01338 C16.0849136,28.0176518 16.0585907,27.82445 16.0551034,27.7983433 C16.0239204,27.621237 15.9927436,27.4393519 15.9639673,27.2670367 C15.8920175,26.8793352 15.808077,26.4964126 15.712146,26.11349 C15.5082871,25.3117419 15.2540651,24.5219411 14.9494863,23.7560959 C14.9135144,23.6531847 14.8727414,23.557454 14.829574,23.4569384 L14.8626832,23.5341828 L14.8626832,23.5341828 L14.853,23.512 C14.9009709,23.6257447 14.8136097,23.4147534 14.7876955,23.3555253 L14.7816054,23.3420616 C14.6928699,23.1434197 14.6017339,22.9519584 14.5058028,22.7557121 C14.3427169,22.4158606 14.1868327,22.068847 14.038138,21.7218211 C13.7927568,21.1406941 13.5750655,20.548541 13.3858329,19.9478604 C11.2345201,21.8489218 8.7000375,22.7891603 6.17316292,22.3535417 C3.53578209,21.8989778 1.38520382,20.0367977 -8.80406859e-14,17.3521189 C2.21146724,15.2861715 4.85683185,14.2423047 7.49307879,14.6922156 C9.74127801,15.0797024 11.6357433,16.4900302 13.0039213,18.5607651 C12.547981,16.6446525 12.3773717,14.6632318 12.5149651,12.6935483 C11.2978883,10.3677783 10.960346,7.86335475 11.7666131,5.55237782 C12.6827625,2.91976957 14.9131522,1.00515653 17.8222734,0 Z"
          id="hc-path-26"
        ></path>
        <linearGradient
          x1="50%"
          y1="100%"
          x2="50%"
          y2="0%"
          id="hc-linearGradient-27"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M2.50177223,29.6735837 C3.13714687,29.656523 3.77255504,29.6735837 4.40792967,29.6735837 L4.40792967,29.6735837 L18.225428,29.6735837 C18.5922382,29.6735837 18.8647333,30.0006013 18.8804558,30.3845121 C18.8961851,30.7684083 18.5686544,31.0954405 18.225428,31.0954405 L18.225428,31.0954405 L18.1992249,31.0954405 C17.9874333,31.1011286 17.7756381,31.1030247 17.5638416,31.1030247 L17.4400001,31.1020011 L15.5415881,41.7986845 C15.479901,42.1462364 15.1777749,42.39946 14.8247911,42.39946 L5.87858633,42.39946 C5.52560896,42.39946 5.22348642,42.1462454 5.1617923,41.7987014 L3.26100007,31.0950011 L2.47557246,31.0954405 C2.14210864,31.0954405 1.88659676,30.825166 1.83107833,30.4875982 L1.82054465,30.3845121 C1.80481539,30.0006158 2.13234607,29.6735837 2.47557246,29.6735837 L2.47557246,29.6735837 Z"
          id="hc-path-28"
        ></path>
      </defs>
      <g
        id="hc-Wireframe-v4-Layout-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="hc-PWA-Desktop-Page0---Home"
          transform="translate(-391.000000, -490.000000)"
        >
          <g id="hc-Group-4" transform="translate(320.000000, 426.000000)">
            <g id="hc-Group-2">
              <g id="hc-Group" transform="translate(68.000000, 64.000000)">
                <g id="hc-Group-7" transform="translate(2.000000, 0.000000)">
                  <g id="hc-ac" transform="translate(94.000000, 0.000000)">
                    <g
                      id="hc-Combined-Shape"
                      transform="translate(23.674540, 15.500100) scale(-1, 1) translate(-23.674540, -15.500100) "
                    >
                      <use fill="#00AEEF" href="#hc-path-2"></use>
                      <use
                        fill="url(#hc-linearGradient-1)"
                        style={{ mixBlendMode: "screen" }}
                        href="#hc-path-2"
                      ></use>
                    </g>
                    <g id="hc-Rectangle">
                      <use fill="#487FB4" href="#hc-path-4"></use>
                      <use
                        fillOpacity="0.5"
                        fill="url(#hc-linearGradient-3)"
                        style={{ mixBlendMode: "multiply" }}
                        href="#hc-path-4"
                      ></use>
                    </g>
                  </g>
                  <g
                    id="hc-Group-3"
                    transform="translate(21.563998, 71.500000) scale(-1, 1) translate(-21.563998, -71.500000) translate(0.063998, 39.500000)"
                  >
                    <g id="hc-Combined-Shape">
                      <use fill="#00AEEF" href="#hc-path-6"></use>
                      <use
                        fill="url(#hc-linearGradient-5)"
                        style={{ mixBlendMode: "screen" }}
                        href="#hc-path-6"
                      ></use>
                    </g>
                    <g id="hc-Combined-Shape">
                      <use fill="#00AEEF" href="#hc-path-8"></use>
                      <use
                        fill="url(#hc-linearGradient-7)"
                        style={{ mixBlendMode: "screen" }}
                        href="#hc-path-8"
                      ></use>
                    </g>
                    <g
                      id="hc-Group-7"
                      transform="translate(7.063998, 16.500000)"
                    >
                      <g id="hc-Fill-1">
                        <use fill="#00AEEF" href="#hc-path-10"></use>
                        <use
                          fill="url(#hc-linearGradient-9)"
                          style={{ mixBlendMode: "screen" }}
                          href="#hc-path-10"
                        ></use>
                      </g>
                      <g id="hc-Combined-Shape">
                        <use fill="#487FB4" href="#hc-path-12"></use>
                        <use
                          fillOpacity="0.5"
                          fill="url(#hc-linearGradient-11)"
                          style={{ mixBlendMode: "multiply" }}
                          href="#hc-path-12"
                        ></use>
                      </g>
                      <g id="hc-Fill-5">
                        <use fill="#487FB4" href="#hc-path-14"></use>
                        <use
                          fillOpacity="0.5"
                          fill="url(#hc-linearGradient-13)"
                          style={{ mixBlendMode: "multiply" }}
                          href="#hc-path-14"
                        ></use>
                      </g>
                      <g id="hc-Fill-6">
                        <use fill="#487FB4" href="#hc-path-16"></use>
                        <use
                          fillOpacity="0.5"
                          fill="url(#hc-linearGradient-15)"
                          style={{ mixBlendMode: "multiply" }}
                          href="#hc-path-16"
                        ></use>
                      </g>
                    </g>
                    <g id="hc-Oval-31">
                      <use fill="#00AEEF" href="#hc-path-18"></use>
                      <use
                        fill="url(#hc-linearGradient-17)"
                        style={{ mixBlendMode: "screen" }}
                        href="#hc-path-18"
                      ></use>
                    </g>
                  </g>
                  <g
                    id="hc-display"
                    transform="translate(21.000000, 32.000000)"
                  >
                    <path
                      d="M44,18.556579 C47,21.5611375 50.3906616,30.637224 49.4508077,37.9294675 C47.8169359,37.9294675 46.1666667,37.9294675 44.5,37.9294675"
                      id="hc-Path-11"
                      stroke="#00AEEF"
                      strokeWidth="2"
                      strokeLinecap="round"
                    ></path>
                    <path
                      d="M1.9775318,1.93165761 L43.4775318,4.4018957 C43.6095998,4.40975689 43.7126771,4.51915223 43.7126771,4.65145399 L43.7126771,31.1803309 C43.7126771,31.3126327 43.6095998,31.422028 43.4775318,31.4298892 L1.9775318,33.9001273 C1.83970456,33.9083313 1.72132285,33.8032509 1.71311885,33.6654237 C1.71282444,33.6604776 1.71267714,33.6555238 1.71267714,33.650569 L1.71267714,2.18121589 C1.71267714,2.04314471 1.82460595,1.93121589 1.96267714,1.93121589 C1.96763197,1.93121589 1.97258571,1.9313632 1.9775318,1.93165761 Z"
                      id="hc-Rectangle"
                      fill="url(#hc-linearGradient-19)"
                      filter="url(#filter-20)"
                      transform="translate(22.712677, 17.915892) rotate(3.000000) translate(-22.712677, -17.915892) "
                    ></path>
                    <g
                      id="hc-Rectangle-Copy-2"
                      transform="translate(43.750000, 19.000000) rotate(3.000000) translate(-43.750000, -19.000000) "
                    >
                      <use fill="#00AEEF" href="#hc-path-22"></use>
                      <use
                        fill="url(#hc-linearGradient-21)"
                        style={{ mixBlendMode: "screen" }}
                        href="#hc-path-22"
                      ></use>
                    </g>
                  </g>
                  <g id="hc-Fill-1">
                    <use fill="#00AEEF" href="#hc-path-24"></use>
                    <use
                      fill="url(#hc-linearGradient-23)"
                      style={{ mixBlendMode: "screen" }}
                      href="#hc-path-24"
                    ></use>
                  </g>
                  <g
                    id="hc-plant"
                    transform="translate(145.500000, 82.100000) scale(-1, 1) translate(-145.500000, -82.100000) translate(131.000000, 60.600000)"
                  >
                    <g
                      id="hc-Combined-Shape"
                      transform="translate(14.105001, 16.835001) scale(-1, 1) translate(-14.105001, -16.835001) "
                    >
                      <use fill="#8FD5EF" href="#hc-path-26"></use>
                      <use
                        fill="url(#hc-linearGradient-25)"
                        style={{ mixBlendMode: "screen" }}
                        href="#hc-path-26"
                      ></use>
                    </g>
                    <g id="hc-Combined-Shape">
                      <use fill="#00AEEF" href="#hc-path-28"></use>
                      <use
                        fill="url(#hc-linearGradient-27)"
                        style={{ mixBlendMode: "screen" }}
                        href="#hc-path-28"
                      ></use>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
